import React, { Component } from "react";
import { arrayOf, shape } from "prop-types";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import gql from "graphql-tag";
import { Query } from "react-apollo";
import Checkbox from "@material-ui/core/Checkbox";

const QUERY = gql`
  query {
    allFiles {
      id
      filename
      name
    }
  }
`;

class FileSelector extends Component {
  state = {
    opened: false,
    selected: undefined
  };

  handleClickOpen = () => {
    this.setState({ opened: true });
  };

  handleClose = () => {
    this.setState({ opened: false, selected: undefined });
  };

  selectItem = item => {
    this.setState({ selected: item });
  };

  render() {
    const { onSubmit } = this.props;
    return (
      <div>
        <Button
          variant="outlined"
          color="primary"
          onClick={this.handleClickOpen}
        >
          Agregar
          <AddIcon />
        </Button>
        <Dialog
          open={this.state.opened}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          scroll="paper"
        >
          <DialogTitle id="form-dialog-title">
            Seleccionar un archivo
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Por favor selecciona un archivo de la lista para asociar al
              indicador
            </DialogContentText>
            <Query query={QUERY}>
              {({ data, loading, error }) => {
                const { allFiles } = data;
                if (loading) {
                  return "Cargando ...";
                } else if (error) {
                  return "Error al cargar los datos ...";
                } else {
                  return (
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell />
                          <TableCell>Nombre para mostrar</TableCell>
                          <TableCell align="right">Nombre archivo</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {allFiles.map(row => {
                          const isSelected = this.state.selected
                            ? this.state.selected.id === row.id
                            : false;
                          return (
                            <TableRow
                              hover
                              onClick={() => this.selectItem(row)}
                              key={row.id}
                              selected={isSelected}
                            >
                              <TableCell>
                                <Checkbox
                                  checked={isSelected}
                                  onChange={() => this.selectItem(row)}
                                  value={row.id}
                                />
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {row.name}
                              </TableCell>
                              <TableCell align="right">
                                {row.filename}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  );
                }
              }}
            </Query>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancelar
            </Button>
            <Button
              onClick={() => {
                onSubmit(this.state.selected);
                this.handleClose();
              }}
              disabled={this.state.selected === undefined}
              color="primary"
            >
              Guardar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

FileSelector.propTypes = {
  files: arrayOf(shape({}))
};

export default FileSelector;



// WEBPACK FOOTER //
// ./src/components/admin/indicators/file-selector.js